import request from './axiosFun';
import apiHttp from './apiHttp';
// 人员列表
var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}
// 设备列表
export function getDsList(data) {
  return request({
    url: url + '/device/cameraDevice/getDsList',
    method: 'post',
    data
  });
}
// 字典 cattle_type牛品种
export function zidian(data) {
  return request({
    url: url + '/base-server/homeCenter/sysInfo/findDictList',
    method: 'post',
    data: data
  });
}
// 设备是否在线
export function getDeviceRelation(data) {
  return request({
    url: url + 'pasture/dynamicData/getDeviceRelation',
    method: 'post',
    data: data
  });
}
// 在栏畜只/
export function livestockinthebarn(data) {
  return request({
    url: url + '/livestock/livestockInfo/pageLivestockInfo',
    method: 'post',
    data: data
  });
}

// 在栏畜只 - 出栏
export function livestockinthebatchSuch(data) {
  return request({
    url: url + '/livestock/livestockInfo/batchSuch',
    method: 'post',
    data: data
  });
}

// 在栏畜只 - 饮水记录/
export function findWaterMonitor(data) {
  return request({
    url: url + '/livestock/waterMonitor/findWaterMonitor',
    method: 'post',
    data: data
  });
}

// 查询1测温2步数3体重4位置
export function chaxunwenbutiwei(data) {
  return request({
    url: url + '/livestock/livestockInfo/findByLivestockTempList',
    method: 'post',
    data: data
  });
}
// 畜只详情
export function stockxuzhixiangqing(data) {
  return request({
    url: url + '/livestock/livestockInfo/getLivestockInfo',
    method: 'post',
    data: data
  });
}
// 畜只统计（按照类型）/
export function xuzhitongji(data) {
  return request({
    url: url + '/livestock/livestockInfo/typeCount',
    method: 'post',
    data: data
  });
}
// id查询免疫用药
export function idmianyiyongyao(data) {
  return request({
    url: url + '/livestock/usedruginfo/pageUseDrug',
    method: 'post',
    data: data
  });
}
// id查询繁育
export function idlishifanyu(data) {
  return request({
    url: url + '/livestock/livestockInfo/breedingInfoList',
    method: 'post',
    data: data
  });
}
// 根据免疫编号查询该批次的畜只列表
export function getUseDrugLivestockListByRecordNo(data) {
  return request({
    url: url + '/livestock/usedruginfo/getUseDrugLivestockListByRecordNo',
    method: 'post',
    data: data
  });
}
// 出栏/淘汰
export function chulantaotai(data) {
  return request({
    url: url + '/livestock/livestockInfo/pageStatusLivestockInfo',
    method: 'post',
    data: data
  });
}
// 免疫用药记录
export function Immunotherapy(data) {
  return request({
    url: url + '/livestock/usedruginfo/pageUseDrug',
    method: 'post',
    data: data
  });
}
// 生产记录
export function productionrecords(data) {
  return request({
    url: url + '/livestock/livestockInfo/productionLogList',
    method: 'post',
    data: data
  });
}
// 生产记录详情
export function xiangproductionrecords(data) {
  return request({
    url: url + '/livestock/livestockInfo/breedingInfo',
    method: 'post',
    data: data
  });
}
// 配种记录
export function breedingrecord(data) {
  return request({
    url: url + '/livestock/livestockInfo/findBreedInfoList',
    method: 'post',
    data: data
  });
}

// 智能设备 - 设备列表
export function queryShackSensingDevicePage(data) {
  return request({
    url: url + '/livestock/shedShackJoinData/queryShackSensingDevicePage',
    method: 'post',
    data: data
  });
}

// 智能设备 - 设备列表 - 新的
export function queryShackSensingDevicePcPage(data) {
  return request({
    url: url + '/livestock/shedShackJoinData/queryShackSensingDevicePcPage',
    method: 'post',
    data: data
  });
}

// 智能设备 - 获取指定传感设备的阈值设置数据
export function getSenseDeviceWarningRuleStrategy(data) {
  return request({
    url: url + '/pasture/warningInfo/getSenseDeviceWarningRuleStrategy',
    method: 'post',
    data: data
  });
}

// 智能设备 - 控制设备
export function queryShackControlDevicePage(data) {
  return request({
    url: url + '/livestock/shedShackJoinData/queryShackControlDevicePage',
    method: 'post',
    data: data
  });
}

// 智能设备 - 智能风机
export function queryFanDevicePage(data) {
  return request({
    url: url + '/livestock/shedShackJoinData/queryFanDevicePage',
    method: 'post',
    data: data
  });
}

// 智能设备 - 获取统计数据
export function queryTabDeviceTypeCount(data) {
  return request({
    url: url + '/livestock/shedShackJoinData/queryTabDeviceTypeCount',
    method: 'post',
    data: data
  });
}

// 智能设备 - 设备列表/控制设备 增加修改接口
export function addOrUpdShackControlDeviceBean(data) {
  return request({
    url: url + '/livestock/shedShackJoinData/addOrUpdShackControlDeviceBean',
    method: 'post',
    data: data
  });
}

// 智能设备 - 设备列表/控制设备 删除接口
export function delShedShackJoinDataById(data) {
  return request({
    url: url + '/livestock/shedShackJoinData/delShedShackJoinDataById',
    method: 'post',
    data: data
  });
}

// 智能设备 - 设备列表/控制设备 - 配置开关接口
export function addControlDeviceItem(data) {
  return request({
    url: url + '/livestock/shedShackJoinData/addControlDeviceItem',
    method: 'post',
    data: data
  });
}

// 智能设备 - 设备列表/控制设备 - 删除开关配置
export function delControlDeviceItem(data) {
  return request({
    url: url + '/livestock/shedShackJoinData/delControlDeviceItem',
    method: 'post',
    data: data
  });
}

// 智能设备 - 设备列表/控制设备 - 传感信息下拉接口
export function getSenseDeviceItemList(data) {
  return request({
    url: url + '/pasture/warningInfo/getSenseDeviceItemList',
    method: 'post',
    data: data
  });
}

// 智能设备 - 设备列表/控制设备 - 获取开关阈值信息
export function getSenseDeviceRuleStrategyBySwitchId(data) {
  return request({
    url: url + '/pasture/warningInfo/getSenseDeviceRuleStrategyBySwitchId',
    method: 'post',
    data: data
  });
}

// 智能设备 - 设备列表/控制设备 - 获取开关阈值信息 - 20240528更换
export function getJoinDataItemInfoBySwitchId(data) {
  return request({
    url: url + '/livestock/shedShackJoinData/getJoinDataItemInfoBySwitchId',
    method: 'post',
    data: data
  });
}

// 智能设备 - 智能风机 编辑接口
export function updFanDevice(data) {
  return request({
    url: url + '/livestock/shedShackJoinData/updFanDevice',
    method: 'post',
    data: data
  });
}

// 智能设备 - 感知状态一张图接口
export function queryShedShackDeviceGroup(data) {
  return apiHttp({
    url: url + '/livestock/shedShackJoinData/queryShedShackDeviceGroup',
    method: 'post',
    data: data
  });
}

// 智能设备 - 精准调控 - 获取其他设备的阈值下拉列表
export function getEnvSettingDevice(data) {
  return request({
    url: url + '/pasture/warningInfo/getEnvSettingDevice',
    method: 'post',
    data: data
  });
}

// 智能设备 - 精准调控 - 查询当前设备阈值
export function getOneEnvSettingDevice(data) {
  return request({
    url: url + '/pasture/warningInfo/getOneEnvSettingDevice',
    method: 'post',
    data: data
  });
}

// 智能设备 - 精准调控 - 保持阈值配置
export function operateEnvValSettings(data) {
  return request({
    url: url + '/pasture/warningInfo/operateEnvValSettings',
    method: 'post',
    data: data
  });
}

// 智能设备 - 控制开关 - 数据
export function findSwitchListByJoinId(data) {
  return request({
    url: url + '/livestock/shedShackJoinData/findSwitchListByJoinId',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 区管理
export function pageQueryShedGroupList(data) {
  return request({
    url: url + '/livestock/shedGroup/pageQueryShedGroupList',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 区管理 - 新增
export function addShedGroup(data) {
  return request({
    url: url + '/livestock/shedGroup/addShedGroup',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 区管理 - 修改
export function updShedGroup(data) {
  return request({
    url: url + '/livestock/shedGroup/updShedGroup',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 区管理 - 删除
export function delShedGroup(data) {
  return request({
    url: url + '/livestock/shedGroup/delShedGroup',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 棚管理 - 列表
export function pageQueryShedShackList(data) {
  return request({
    url: url + '/livestock/shedShack/pageQueryShedShackList',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 棚管理 - 区下拉框数据
export function queryShedGroupList(data) {
  return apiHttp({
    url: url + '/livestock/shedGroup/queryShedGroupList',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 棚管理 - 添加
export function addShedShack(data) {
  return request({
    url: url + '/livestock/shedShack/addShedShack',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 棚管理 - 修改
export function updShedShack(data) {
  return request({
    url: url + '/livestock/shedShack/updShedShack',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 棚管理 - 删除
export function delShedShack(data) {
  return request({
    url: url + '/livestock/shedShack/delShedShack',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 棚管理 - 下载模版
export function downLoadTemplate(data) {
  return request({
    url: url + '/livestock/shedShack/downLoadTemplate',
    method: 'get',
    data: data
  });
}

// 圈舍管理 - 棚管理 - 导入棚
export function importShack(data) {
  return request({
    url: url + '/livestock/shedShack/importShack',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 栏管理 - 列表
export function pageQueryShedHurdleList(data) {
  return request({
    url: url + '/livestock/shedHurdle/pageQueryShedHurdleList',
    method: 'post',
    data: data
  });
}

// 栏下拉列表
export function queryShedHurdleList(query) {
  return request({
    url: url + '/livestock/shedHurdle/queryShedHurdleList',
    method: 'post',
    data: query
  });
}

// 圈舍管理 - 栏管理 - 棚下拉框数据
export function queryShedShackList2(data) {
  return request({
    url: url + '/livestock/shedShack/queryShedShackList2',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 栏管理 - 添加
export function batchAddShedHurdle(data) {
  return request({
    url: url + '/livestock/shedHurdle/batchAddShedHurdle',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 栏管理 - 修改
export function updShedHurdle(data) {
  return request({
    url: url + '/livestock/shedHurdle/updShedHurdle',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 栏管理 - 删除
export function delShedHurdle(data) {
  return request({
    url: url + '/livestock/shedHurdle/delShedHurdle',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 栏管理 - 下载模版
export function downLoadShedTemplate(data) {
  return request({
    url: url + '/livestock/shedHurdle/downLoadTemplate',
    method: 'get',
    data: data
  });
}

// 圈舍管理 - 栏管理 - 导入栏
export function importHurdle(data) {
  return request({
    url: url + '/livestock/shedHurdle/importHurdle',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 栏管理 - 选择设备
export function findAntennaByShackId(data) {
  return request({
    url: url + '/livestock/shedHurdle/findAntennaByShackId',
    method: 'post',
    data: data
  });
}

// 圈舍管理 - 栏管理 - 天线编号
export function findAntennaByMacNo(data) {
  return request({
    url: url + '/livestock/shedHurdle/findAntennaByMacNo',
    method: 'post',
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/livestocker.js